import { Box, ButtonNew, ColorOptions, Icon, Image, Spacer, Text, TextNew } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { useState } from 'react'
import ReactDOM from 'react-dom'
import { Animated, FlatList, GestureResponderEvent, Linking, StyleProp } from 'react-native'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { jiopayBusinessProductData, pgProductData } from '../../static/staticData'
import { staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import usePadding from '../../util/usePadding'
import { isJiopayBizzEnable, isMobileWidth, isTabletWidth, useWindowDimensions } from '../../util/util'
import DottedImage, { dottedImageTypes } from '../ImageDotted'
import { LinearGradientContainer } from '../LinearGradient'
import { ToolTipBorder } from '../ToolTipBorder'
import { styles as megaMenuStyle } from './styles'

interface ProductsModalInterface {
  visible: boolean
  productLayout?: GestureResponderEvent
  showProductModal?: () => void
  hideProductModal?: () => void
}
const zIndex = 9999
interface RenderItemInterface {
  item: {
    id: string
    headerText: string
    desc: string
    customColor?: ColorOptions
    icon?: string
    path: string
    component?: () => JSX.Element
  }
  hideProductModal?: () => void
  styles: StyleProp<any>
  index?: number
}

const RenderItem = ({ item, hideProductModal, styles, index }: RenderItemInterface) => {
  const { navigate } = useNavigation()
  const [hovering, updateRenderItemHovering] = useState(false)
  const onItemHover = (isHovering: boolean) => {
    updateRenderItemHovering(isHovering)
  }
  const Component = item.component
  return (
    <Box
      {...styles.renderItem}
      onHover={onItemHover}
      onPress={() => [navigate(item?.path), hideProductModal && hideProductModal()]}
      underlayColor={'TRANSPARENT'}>
      <Box flexDirection={'row'}>
        <Box {...styles.imageWrap}>
          {!!Component && <Component {...styles.prodIcons} />}
          {!!item.icon && <Image source={item.icon} {...styles.prodIcons} resizeMode="contain" />}
        </Box>
        <Spacer direction="horizontal" size={16} />
        <Box maxWidth={'11vw'}>
          <TextNew {...styles.categoryTextHeader} title={item?.headerText} />
          <Box {...styles.descWrapper}>
            <TextNew {...styles.categoryTextDesc} title={item?.desc} />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const RenderPgProductItem = ({ item, hideProductModal, styles, index }: RenderItemInterface) => {
  const { navigate } = useNavigation()
  const [hovering, updateRenderItemHovering] = useState(false)
  const onItemHover = (isHovering: boolean) => {
    updateRenderItemHovering(isHovering)
  }

  const Component: any = item.component
  return (
    <Box
      {...styles.renderItem}
      onHover={onItemHover}
      onPress={() => [navigate(item?.path), hideProductModal && hideProductModal()]}
      underlayColor={'TRANSPARENT'}>
      <Box flexDirection={'row'}>
        <Box {...styles.imageWrap}>
          {!!item.component && <Component {...styles.iconStyle} />}
          {typeof item.icon === 'string' && <Icon id={item.icon as any} color={'BLUE'} size={24} />}
          {(!!item.icon && typeof item.icon !== 'string') ||
            (typeof item.icon === 'string' && item.icon.length > 100 && (
              <Image source={item.icon} {...styles.iconStyle} resizeMode="contain" />
            ))}
        </Box>
        <Spacer direction="horizontal" size={24} />
        <Box maxWidth={'11vw'}>
          <TextNew {...styles.categoryTextHeader} title={item?.headerText} />
          <Box {...styles.descWrapper}>
            <TextNew {...styles.categoryTextDesc} title={item?.desc} />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

interface RenderDropDownInterface {
  visible?: boolean
  showProductModal?: () => void
  hideProductModal?: () => void
  productLayout?: GestureResponderEvent | any
  width: number
  isScreenType?: boolean
  timeoutId?: number
}

export const openPlayStore = () => {
  Linking.openURL(staticStrings.playStoreLink)
}

export const RenderProductMetaData = ({
  visible,
  productLayout,
  width,
  isScreenType = false,
  showProductModal,
  hideProductModal,
}: RenderDropDownInterface) => {
  const { navigate } = useNavigation()
  const top = isScreenType ? 0 : productLayout?.y ?? 30
  const isMobile = isMobileWidth(width)
  const isTab = isTabletWidth(width)

  const onHover = () => {
    if (!isScreenType && visible) {
      hideProductModal && hideProductModal()
    }
  }

  const onSubMenuHover = (isHovering: boolean) => {
    if (!visible && isHovering) {
      showProductModal && showProductModal()
    }
  }

  const resPadding = usePadding()
  const styles = megaMenuStyle(isScreenType, width, resPadding)

  const [pgProductsVisible, setPgProductsVisible] = useState(false)
  const onKnowMorePress = () => {
    navigate('jio-pay-business')
    hideProductModal && hideProductModal()
  }

  const [productsAnimatedValue] = useState<any>(new Animated.Value(0))

  const startProductsAnimation = (hide?: boolean) => {
    Animated.timing(productsAnimatedValue, {
      toValue: pgProductsVisible ? 24 : 640,
      duration: 600,
      useNativeDriver: true,
    }).start(hide ? () => setPgProductsVisible(false) : () => {})
  }

  const handleOnPress = () => {
    if (pgProductsVisible) {
      startProductsAnimation(true)
    } else {
      setPgProductsVisible(!pgProductsVisible)
      startProductsAnimation(false)
    }
  }
  return (
    <Box
      position={'absolute'}
      right={0}
      left={0}
      top={0}
      bottom={0}
      underlayColor="TRANSPARENT"
      onPress={() => onHover()}
      height={isTab && !isScreenType ? '100vh' : undefined}>
      <ModBox {...styles.tooltipStyle()} show={isScreenType ? false : visible} />
      <ModBox
        {...styles.modal(resPadding, top, width)}
        show={isScreenType ? true : visible}
        zIndex={zIndex}
        disabled={isScreenType}
        onHover={(hovering: any) => {
          !hovering && onHover()
        }}
        onPress={() => {
          if (isTab) {
            return
          } else {
            hideProductModal && hideProductModal()
          }
        }}>
        <Box onHover={onSubMenuHover} {...styles.mainView()}>
          <Box {...styles.productMetaDataWrap(top)}>
            <Box {...styles.flatlistWrapper}>
              <ModBox show={!isScreenType} {...styles.topHeader}>
                <Text hide={isScreenType} {...styles.headerTitle} title={'JioPay For Business Products'} />
                <Icon id={'ARROW_RIGHT'} color={'BLACK_75'} size={24} />
              </ModBox>
              <Box {...styles.renderedContentMainGroup}>
                <FlatList
                  data={jiopayBusinessProductData(isScreenType)}
                  horizontal
                  showsVerticalScrollIndicator={false}
                  scrollEnabled={false}
                  showsHorizontalScrollIndicator={false}
                  renderItem={({ item, index }) => (
                    <RenderItem item={item} hideProductModal={hideProductModal} styles={styles} index={index} />
                  )}
                  key={isMobile ? 'm' : 'd'}
                  keyExtractor={(item) => item.id}
                />
                <ModBox
                  flexDirection={'row'}
                  align={'center'}
                  pl={80}
                  pt={12}
                  onPress={handleOnPress}
                  underlayColor={'TRANSPARENT'}>
                  <Text
                    title={'Explore Products'}
                    fontFamily={'jiotype-medium'}
                    fontSize={12}
                    color={colors.HIGHLIGHT}
                  />
                  <Spacer size={4} direction={'horizontal'} />
                  <Icon id={pgProductsVisible ? 'ARROW_UP' : 'ARROW_DOWN'} color={'BLUE'} size={24} />
                </ModBox>
              </Box>
            </Box>
            <Animated.View style={{ maxHeight: productsAnimatedValue }}>
              <ModBox show={pgProductsVisible}>
                <ToolTipBorder left={100}>
                  <LinearGradientContainer colorArray={['#0070B60A', '#FFFFFF05']} useAngle={true} angle={180}>
                    <Box {...styles.flatlistWrapper}>
                      <ModBox {...styles.topHeader}>
                        <Text
                          title={'PAYMENT GATEWAY PRODUCTS'}
                          fontFamily={'jiotype-medium'}
                          color={'#A0A0A0' as ColorOptions}
                          fontSize={12}
                          letterSpacing={1.2}
                        />
                      </ModBox>
                      <Box {...styles.renderedContentMainGroup} mb={36}>
                        <FlatList
                          data={pgProductData(isScreenType)}
                          numColumns={isMobile ? 1 : 4}
                          showsVerticalScrollIndicator={false}
                          renderItem={({ item, index }) => (
                            <RenderPgProductItem
                              item={item}
                              hideProductModal={hideProductModal}
                              styles={styles}
                              index={index}
                            />
                          )}
                          key={isMobile ? 'm' : 'd'}
                          keyExtractor={(item) => item.id}
                        />
                      </Box>
                    </Box>
                  </LinearGradientContainer>
                </ToolTipBorder>
              </ModBox>
            </Animated.View>
            {isJiopayBizzEnable && (
              <Box {...styles.footerView} mt={pgProductsVisible ? 0 : 24}>
                <Box {...styles.leftImgContainer}>
                  <Box {...styles.jioBizImageContainer}>
                    <Image
                      resizeMode="contain"
                      source={require('../../assets/images/jio-pay.png')}
                      width={isScreenType ? (isMobile ? 140 : isTab ? 100 : 200) : 140}
                      height={isScreenType ? 120 : isMobile ? 100 : 120}
                    />
                  </Box>
                  <Box {...styles.businessAppContainer}>
                    <TextNew {...styles.boldHeader} title={'JioPay Business App'} />
                    <Spacer size={isScreenType ? 8 : 1} />
                    <TextNew
                      {...styles.footerDescription}
                      title={isTab ? staticStrings.simpleInstantUpiTab : staticStrings.simpleInstantUpi}
                    />
                  </Box>
                </Box>
                <Box {...styles.googlePlayView}>
                  <ButtonNew
                    height={32}
                    color="transparent"
                    onPress={onKnowMorePress}
                    borderWidth={1}
                    borderRadius={4}
                    children={
                      <TextNew
                        fontFamily="jiotype-medium"
                        fontSize={12}
                        color={colors.HIGHLIGHT as ColorOptions}
                        title={'Know More'}
                      />
                    }
                    borderColor={colors.HIGHLIGHT as ColorOptions}
                    type="tertiary"
                  />
                  <Spacer size={20} direction="horizontal" />
                  <Box {...styles.underlayedTrans} onPress={openPlayStore}>
                    <Image
                      source={require('../../assets/images/google-play.png')}
                      {...styles.imgStyle}
                      resizeMode={'stretch'}
                    />
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
          <ModBox show={isScreenType && !isMobile} zIndex={-99} right={47} bottom={isMobile ? 0 : -20} width={'100%'}>
            <DottedImage position={dottedImageTypes.bottomRight} isDark={true} size={isMobile ? 60 : 150} />
          </ModBox>
        </Box>
      </ModBox>
    </Box>
  )
}

export const ProductsMegaMenu = ({
  visible,
  productLayout,
  showProductModal,
  hideProductModal,
}: ProductsModalInterface) => {
  const width = useWindowDimensions()
  if (!visible) {
    return null
  } else {
    return ReactDOM.createPortal(
      visible && (
        <RenderProductMetaData
          visible={visible}
          productLayout={productLayout}
          width={width}
          isScreenType={false}
          hideProductModal={hideProductModal}
          showProductModal={showProductModal}
        />
      ),
      document.body,
    )
  }
}
